export var Status;
(function (Status) {
    Status["ACCEPTED"] = "ACCEPTED";
    Status["REJECTED"] = "REJECTED";
    Status["CANCELLED"] = "CANCELLED";
})(Status || (Status = {}));
export var Type;
(function (Type) {
    Type["JOIN_REQUEST"] = "JOIN_REQUEST";
    Type["INVITATION"] = "INVITATION";
    Type["STEP_CONFIRMATION"] = "STEP_CONFIRMATION";
})(Type || (Type = {}));
//# sourceMappingURL=types.impl.js.map